export default __webpack_public_path__ + "static/media/newsletter_circle.7e3bba7a.png";